export enum TtsClaimStatus {
    New = "N",
    OpsRejected = "OR",
    Processing = "P",
    PendingClient = "PC",
    PendingTPAAssessment = "PTA",
    PendingInsurerEvaluation = "PIE",
    InsurerApproved = "IA",
    InsurerRejected = "IR",
    TPARejected = "TR",
    PendingRepairReplace = "PRR",
    Completed = "C",
    Disbursed = "D",
}

export const TTS_CLAIM_STATUS_LABELS: Record<TtsClaimStatus, string> = {
    [TtsClaimStatus.New]: "New",
    [TtsClaimStatus.OpsRejected]: "Ops Rejected",
    [TtsClaimStatus.Processing]: "Processing",
    [TtsClaimStatus.PendingClient]: "Pending Client",
    [TtsClaimStatus.PendingTPAAssessment]: "Pending TPA Assessment",
    [TtsClaimStatus.PendingInsurerEvaluation]: "Pending Insurer Evaluation",
    [TtsClaimStatus.InsurerApproved]: "Insurer Approved",
    [TtsClaimStatus.InsurerRejected]: "Insurer Rejected",
    [TtsClaimStatus.TPARejected]: "TPA Rejected",
    [TtsClaimStatus.PendingRepairReplace]: "Pending Repair/Replace",
    [TtsClaimStatus.Completed]: "Completed",
    [TtsClaimStatus.Disbursed]: "Disbursed",
};

export function getTtsClaimStatusLabel(status: TtsClaimStatus): string {
    return TTS_CLAIM_STATUS_LABELS[status] ?? String(status);
}

export const TTS_ONGOING_CLAIM_STATUSES = [
    TtsClaimStatus.New,
    TtsClaimStatus.Processing,
    TtsClaimStatus.PendingClient,
    TtsClaimStatus.PendingTPAAssessment,
    TtsClaimStatus.PendingInsurerEvaluation,
    TtsClaimStatus.InsurerApproved,
    TtsClaimStatus.PendingRepairReplace,
];
